import { useState, useCallback } from 'react';

export default initilState => {
  const [state, setState] = useState(initilState);

  const toggle = useCallback(() => setState(!state), [state]);

  return [state, toggle];
};
